import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';

import styles from './styles';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.string,
    checkboxRoot: PropTypes.string,
    checkboxChecked: PropTypes.string,
    errorText: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  errMsg: PropTypes.string,
  touched: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  label: '',
};

const GeneralCheckbox = props => {
  const {
    id,
    label,
    value,
    onChange,
    errMsg,
    touched,
    disabled,
    classes,
  } = props;

  const handleChange = evt => {
    onChange(evt.target.checked);
  };

  const labelElem =
    typeof label === 'function' ? React.createElement(label) : label;

  const labelClass = disabled
    ? [classes.label, classes.disabled].join(' ')
    : classes.label;

  return (
    <>
      <label htmlFor={id} className={classes.root}>
        <Checkbox
          id={id}
          checked={!!value}
          onChange={handleChange}
          classes={{
            root: classes.checkboxRoot,
            checked: classes.checkboxChecked,
          }}
          disabled={disabled}
        />
        <span className={labelClass}>{labelElem}</span>
      </label>
      {touched && errMsg && (
        <FormHelperText id={`${id}-helper-text`} className={classes.errorText}>
          {errMsg}
        </FormHelperText>
      )}
    </>
  );
};

GeneralCheckbox.propTypes = propTypes;
GeneralCheckbox.defaultProps = defaultProps;

export default withStyles(styles)(GeneralCheckbox);
